<template>
	<div>
		<div id="charts"></div>
		 
	</div>
</template>
<script>
	// import echarts from 'echarts'
	// var echart=require('../libs/echarts.min.js')
	export default{
		//  components:{ 'v-chart': echarts},
		mounted() {
			//  console.log(echarts)
		}
	}
</script>